export default "__VITE_ASSET__dZn4Wz00__"